export const environment = {
    production: false,
    backend_url: "https://api.v2.ilmiomedico.info"
  };